










































































import { Component, Vue } from "vue-property-decorator";
import AuthService from "@/services/api/auth.service";
import { AuthenticateModel } from "@/server/app.commands";
import * as AppNotification from "@/models/notifications/notification";

@Component
export default class LoginPage extends Vue {
  authService: AuthService = new AuthService();
  authModel: AuthenticateModel = new AuthenticateModel();
  isLoading: boolean = false;
  isRecovering: boolean = false;
  isValid: boolean = false;
  notification: AppNotification.Notification | null = null;
  url: string = "";

  get Year(): number {
    return new Date().getFullYear();
  }

  updated() {
    this.url = window.location.origin;
  }

  async onSubmit() {
    if (this.isLoading && !this.authModel.username) return;
    this.isLoading = true;
    if (this.isRecovering) {
      this.isLoading = false;
      this.authService
        .StartRecover(this.url, this.authModel.username || "")
        .then(() => {
          this.notification = new AppNotification.Notification(
            "Sucesso",
            "Verifique a sua caixa de email",
            AppNotification.NotificationType.Success
          );
          this.isRecovering = false;
        })
        .catch((error: any) => {
          this.notification = AppNotification.Notification.ConvertFromAxios(
            error
          );
        })
        .finally(() => (this.isLoading = false));

      return;
    }
    this.authModel.idAppInterface = 1;
    await this.authService
      .Login(this.authModel)
      .then(response => {
        this.authService.SetToken(response);
        this.$router.replace("/dashboard");
      })
      .catch((error: any) => {
        this.notification = AppNotification.Notification.ConvertFromAxios(
          error
        );
      })
      .finally(() => (this.isLoading = false));
  }
}
